import { useQuery } from '@hooks/reactQuery';

import { checkPresetForUpdateIsShared } from '@api/kpi';

import { extractQueryParams } from '@utils/common';
import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';
import { IEditPresetNameDTO } from '@interfaces/kpi/dto/kpiDTO';

import { EErrorCodes } from '@enums/errorCodes';

import { refetchOptions } from '@constants/common';
import { CHECK_UPDATE_PRESET_IS_SHARED } from '@constants/queryKeys';

interface IUseQueryCheckPresetForUpdateIsSharedReturnType {
	isPassName: boolean;
	isLoadingCheckPresetForUpdateIsShared: boolean;
}

export const useQueryCheckPresetForUpdateIsShared =
	(params: Partial<IEditPresetNameDTO>): IUseQueryCheckPresetForUpdateIsSharedReturnType => {
	const { id = '', name = '', isShared = true } = params;

	const {
		isSuccess,
		isLoading: isLoadingCheckPresetForUpdateIsShared,
	} = useQuery({
		queryKey: [CHECK_UPDATE_PRESET_IS_SHARED, {
			id,
			name,
			isShared,
		}],
		queryFn: extractQueryParams(checkPresetForUpdateIsShared),
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => item.code === EErrorCodes.kpiPresetAlreadyExists)) {
				handleErrorFromMessage(err);
			}
		},
		enabled: [!!id, !!name],
		...refetchOptions,
	});

	return {
		isPassName: isSuccess,
		isLoadingCheckPresetForUpdateIsShared,
	};
};
